import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { EstampService } from 'src/app/core/services/estamp.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { ConfirmModalService } from 'src/app/core/services/confirm-modal.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-client-order-detail',
  templateUrl: './client-order-detail.component.html',
  styleUrl: './client-order-detail.component.scss'
})
export class ClientOrderDetailComponent implements OnInit {

  orderDetail: any = {};
  generatingInvoice = false;
  rejectingPayment = false;
  rejectReason = '';
  verifyReason = '';
  paymentAction: 'VERIFY' | 'REJECT' | '' = '';

  constructor(
    private location: Location,
    private estampService: EstampService,
    private toastService: ToastService,
    private confirmModalService: ConfirmModalService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.orderDetail = history.state?.order || {};
  }

  back() {
    this.location.back();
  }

  onGenerateInvoice() {
    const id = this.orderDetail?._id;

    if (!id) {
      return;
    }

    this.confirmModalService.open(
      'Generate Invoice',
      'Are you sure you want to generate invoice for this order?',
      () => {
        this.confirmGenerateInvoice(id);
      },
      'Generate',
      'Cancel'
    );
  }

  confirmGenerateInvoice(id: string) {
    this.generatingInvoice = true;

    this.estampService.generateBulkInvoice(id).subscribe({
      next: (res: any) => {
        this.generatingInvoice = false;

        this.toastService.showToaster(
          'Success',
          res?.message || 'Invoice generated successfully',
          'success'
        );

        this.back();
      },
      error: () => {
        this.generatingInvoice = false;
      }
    });
  }

  orderProcess() {
    const id = this.orderDetail?._id;

    if (!id) {
      return;
    }

    if (!this.verifyReason?.trim()) {
      this.toastService.showToaster(
        'Failed',
        'Please enter a reason for verification',
        'error'
      );
      return;
    }

    this.confirmModalService.open(
      'Verify Payment',
      'Are you sure you want to verify this payment?',
      () => {
        this.confirmVerifyPayment(id);
      },
      'Verify',
      'Cancel'
    );
  }

  confirmVerifyPayment(id: string) {
    this.generatingInvoice = true;

    this.estampService.orderProcess(id, this.verifyReason.trim()).subscribe({
      next: (res: any) => {
        this.generatingInvoice = false;

        this.toastService.showToaster(
          'Success',
          res?.message || 'Payment verified successfully',
          'success'
        );

        this.verifyReason = '';
        this.router.navigate(['/estamp/client-order'])
      },
      error: () => {
        this.generatingInvoice = false;
      }
    });
  }

  onRejectPayment() {
    const id = this.orderDetail?._id;

    if (!id) {
      return;
    }

    if (!this.rejectReason?.trim()) {
      this.toastService.showToaster(
        'Failed',
        'Please enter a reason for rejection',
        'error'
      );
      return;
    }

    this.confirmModalService.open(
      'Reject Payment',
      'Are you sure you want to reject this payment?',
      () => {
        this.confirmRejectPayment(id);
      },
      'Reject',
      'Cancel'
    );
  }

  confirmRejectPayment(id: string) {
    this.rejectingPayment = true;

    this.estampService.rejectPayment(id, this.rejectReason.trim()).subscribe({
      next: (res: any) => {
        this.rejectingPayment = false;

        this.toastService.showToaster(
          'Success',
          res?.message || 'Payment rejected successfully',
          'success'
        );

        this.rejectReason = '';
        this.back();
      },
      error: () => {
        this.rejectingPayment = false;
      }
    });
  }
  getStatusClass(status: string): any {
    switch (status) {
      case 'ORDER_CREATED':
        return 'border-secondary text-secondary bg-light';

      case 'UNDER_REVIEW':
      case 'UNDER_CHECKER_REVIEW':
        return 'border-warning text-warning bg-warning-subtle';

      case 'INVOICE_GENERATED':
        return 'border-info text-info bg-info-subtle';

      case 'PAYMENT_SUBMITTED':
        return 'border-primary text-primary bg-primary-subtle';

      case 'PAYMENT_REJECTED':
        return 'border-danger text-danger bg-danger-subtle';

      case 'PAYMENT_VERIFIED':
        return 'border-success text-success bg-success-subtle';

      case 'ESTAMP_UPLOADED':
        return 'border-purple text-purple bg-purple-subtle';

      case 'ORDER_FULFILLED':
      case 'COMPLETED':
        return 'border-success text-success bg-success-subtle';

      default:
        return 'border-dark text-dark bg-light';
    }
  }
}
